import { notify } from '@billy/design-system'
import { trackError } from '@billy/track-error'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { NotificationKeys } from '../../../enums/notificationKeys'
import { QueryKeys } from '../../../enums/queryKeys'
import { fetchVatDeclarationAuditTrail } from '../query-api'
import { formatAuditTrailSubreports } from '../utils/formatAuditTrailSubreports'

interface UseFetchVatDeclarationAuditTrailProps {
  showVoided: boolean
  vatDeclarationId?: string
}

export const useFetchVatDeclarationAuditTrail = ({
  showVoided,
  vatDeclarationId,
}: UseFetchVatDeclarationAuditTrailProps) => {
  const { organization } = useUserOrganization()
  const { t } = useTranslation()

  const organizationId = organization?.id || ''
  const locale = organization?.localeId || 'da_DK'

  const { data, isLoading, isFetching, isError } = useQuery(
    [QueryKeys.VatDeclarationAuditTrail, organizationId, vatDeclarationId, showVoided, locale],
    {
      queryFn: vatDeclarationId ? () => fetchVatDeclarationAuditTrail({ showVoided, vatDeclarationId }) : undefined,
      enabled: !!organizationId && !!vatDeclarationId,
      keepPreviousData: true,
      staleTime: defaultStaleTime,
      select: (response) => formatAuditTrailSubreports({ data: response.data, locale }),
      onError: (error) => {
        trackError(error)
        notify({
          id: NotificationKeys.VatDeclarationAuditTrail,
          message: t('audit_trail.error'),
          variant: 'error',
        })
      },
    },
  )

  return {
    data: data ?? [],
    isError,
    isFetching,
    isLoading,
  }
}
